import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const BOXHERO_LOGO_COLOR =
  "https://customer-assets.emergentagent.com/job_client-hub-266/artifacts/ysfg7n2y_Asset%209blue.png";

export default function Register() {
  const { register, user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", company_name: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user && user !== false) navigate("/", { replace: true });
  }, [user, navigate]);

  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register({ ...form, email: form.email.trim().toLowerCase() });
    setLoading(false);
    if (!res.ok) setError(res.error || "Registration failed");
    else navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-xl p-8 shadow-sm">
        <div className="flex items-center mb-6">
          <img src={BOXHERO_LOGO_COLOR} alt="BoxHero" className="h-10 w-auto" />
        </div>
        <h2 className="text-2xl font-bold text-slate-900" style={{ fontFamily: "Manrope" }}>Create your account</h2>
        <p className="text-sm text-slate-500 mt-1">Start managing your fulfillment in one place.</p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4" data-testid="register-form">
          <Field label="Full name" testId="register-name-input" value={form.name} onChange={onChange("name")} required />
          <Field label="Company name" testId="register-company-input" value={form.company_name} onChange={onChange("company_name")} />
          <Field type="email" label="Work email" testId="register-email-input" value={form.email} onChange={onChange("email")} required />
          <Field type="password" label="Password" testId="register-password-input" value={form.password} onChange={onChange("password")} required />

          {error && <div data-testid="register-error" className="text-sm bg-red-50 border border-red-200 text-red-700 rounded-lg px-4 py-3">{error}</div>}

          <button
            type="submit"
            data-testid="register-submit-btn"
            disabled={loading}
            className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white font-semibold py-3 rounded-lg transition-colors"
          >
            {loading ? "Creating account…" : "Create account"}
          </button>
        </form>

        <p className="mt-6 text-sm text-center text-slate-500">
          Already have an account?{" "}
          <Link to="/login" className="text-blue-600 hover:text-blue-700 font-medium">Sign in</Link>
        </p>
      </div>
    </div>
  );
}

function Field({ label, testId, ...props }) {
  return (
    <div>
      <label className="block text-sm font-medium text-slate-700 mb-1.5">{label}</label>
      <input
        data-testid={testId}
        {...props}
        className="w-full px-4 py-3 border border-slate-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:border-blue-500 text-slate-900"
      />
    </div>
  );
}
